import axios from 'axios';
import apiConfig from '../../api.config';

export default function getCheckOutSubscriptionStatus({ hotelId }) {
  const {
    host,
    URIs: {
      checkOut: { getSubscriptionStatus },
    },
  } = apiConfig;

  const uri = `${host}${getSubscriptionStatus.replace(':hotelId', hotelId)}`;

  return axios
    .get(uri, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then(res => {
      return res.data?.suscription || false;
    }).catch(err => {
      console.error(err);
      return false;
    });
}
